module.exports = __webpack_public_path__ + "img/41.f4cd63e6.jpg";